<div class="container-fluid container--available-viewport-height table-responsive" *ngIf="hospitalContext && hospitalDetails">
  <div class="row justify-content-sm-center mb-3">
    <h5 data-testid="hospital-name">{{ hospitalContext.name }}</h5>
  </div>

  <div class="row justify-content-center">
    <div class="col-6">
      <h5>{{ localizationKey('editHospitalOperatorHospitals') | localize }}</h5>
      <span>{{ hospitalContext.name }}{{ localizationKey('editHospitalChooseOperatorText') | localize }} </span>
      <div class="grid grid-striped" data-testId="hospital-list">
        <div *ngFor="let operatorHospital of hospitalDetails.operatorHospitals" class="row" data-testid='hospital'>
          <div class="col-11"><span>{{ operatorHospital.name }}</span></div>
          <div class="col-1">
            <button class="btn btn-sm btn-danger" [attr.data-testid]='"remove-operator-button-" + operatorHospital.name'
                    (click)="removeOperator(operatorHospital)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-11">
          <select [(ngModel)]="selectedEligibleOperator" data-testId="eligible-hospital-dropdown"
                  class="form-select col-sm-auto ">
            <option *ngFor="let eligibleOperator of eligibleOperators"
                    [ngValue]="eligibleOperator?.id">{{ eligibleOperator?.name }}
            </option>
          </select>
        </div>
        <div class="col-1">
          <button data-testId="add-button" class="form-control col-sm-auto btn btn-sm btn-primary"
                  (click)="addOperator()"
                  [disabled]="selectedEligibleOperator===undefined || selectedEligibleOperator===null">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <hr/>
  <app-allowed-types-section
    [initialAllowedMeasurementTypes]="hospitalDetails.allowedMeasurementTypes"
    (typesChanged)="handleAllowedTypesChange($event)"
  ></app-allowed-types-section>
  <hr/>
  <app-nurse-settings-section
    [nurse2Fa]="hospitalDetails.nurse2Fa"
    [reportDeliveryNotification]="hospitalDetails.nurseReportDeliveryNotification"
    [initiateWithDeviceSerial]="hospitalDetails.nurseInitiatesWithDeviceSerial"
    [hospitalId]="hospitalContext.id"
    (settingsChanged)="handleNurseSettingsChange($event)"
  ></app-nurse-settings-section>

  <hr/>
  <div class="row justify-content-center">
    <div class="col-6">
      <div class="row">
        <h5>{{ localizationKey('hospitalInformationTitle') | localize }}</h5>
      </div>

      <form-field [config]="hospitalDetailsFormConfig!.publicName"></form-field>
      <form-field [config]="hospitalDetailsFormConfig!.operatorAppointmentDescription"></form-field>
      <form-field [config]="hospitalDetailsFormConfig!.address"></form-field>
      <form-field [config]="hospitalDetailsFormConfig!.postalCode"></form-field>
      <form-field [config]="hospitalDetailsFormConfig!.city"></form-field>
    </div>

  </div>

  <hr/>
  <div class="row justify-content-center">
    <div class="col-6">
      <div class="row">
        <h5>{{ localizationKey('hospitalPatientFormTemplatesTitle') | localize }}</h5>
      </div>
      <div class="grid grid-striped">
        <div
          *ngFor="let patientFormTemplateOptionsForMeasurementType of hospitalContext.patientFormTemplateOptionsByMeasurementType | keyvalue"
          class="row">
          <div class="col-6">
            <label
              [attr.for]="patientFormTemplateOptionsForMeasurementType.key + '-patient-form-template-select'">
              {{ getMeasurementTypeLocalizationKey(patientFormTemplateOptionsForMeasurementType.key) | localize }}
            </label>
          </div>
          <div class="col-6">

            <select [attr.id]="patientFormTemplateOptionsForMeasurementType.key + '-patient-form-template-select'"
                    [attr.data-testId]="patientFormTemplateOptionsForMeasurementType.key + '-patient-form-template-select'"
                    [ngModel]="hospitalDetails.selectedPatientFormTemplates.get(patientFormTemplateOptionsForMeasurementType.key)"
                    (ngModelChange)="hospitalDetails.selectedPatientFormTemplates.set(patientFormTemplateOptionsForMeasurementType.key, $event)"
                    class="form-select col-sm-auto ">
              <option *ngFor="let typeOption of patientFormTemplateOptionsForMeasurementType.value"
                      [ngValue]="typeOption">{{ typeOption }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr/>
  <app-report-language-section
    [language]="hospitalDetails.reportLanguageSettings.language"
    [reportLanguageSelectionEnabled]="hospitalDetails.reportLanguageSettings.reportLanguageSelectionEnabled"
    [allowedReportLanguages]="hospitalDetails.reportLanguageSettings.allowedReportLanguages"
    (settingsChanged)="handleLanguageSettingsChange($event)"
  ></app-report-language-section>

  <ng-container *ngIf="putHospitalInChain280Released()">
    <hr/>
    <div class="justify-content-center">
      <app-chain-section
        [chains]="hospitalContext.chains"
        [hospitalChain]="hospitalDetails.hospitalChain"
        [settingChainDisabled]="hospitalChainSet"
        (chainChanged)="handleChainChange($event)"
      ></app-chain-section>
    </div>
  </ng-container>

  <hr/>
  <app-technicians-section
    [assignSleepTechniciansEnabled]="hospitalDetails.assignSleepTechniciansEnabled"
    [hospitalId]="hospitalContext.id"
    [ecgWorkflow]="hospitalDetails.ecgWorkflow"
    (settingsChanged)="handleTechniciansSettingsChange($event)"
  ></app-technicians-section>

  <hr/>
  <div class="row justify-content-center">
    <div class="col-6">
      <div>
        <h5>{{ localizationKey('hospitalExternalAnalysisSettingsTitle') | localize }}</h5>
      </div>
      <div class="row">
        <label class="col-6">
          {{ localizationKey('hospitalExternalAnalysisProviderLabel') | localize }}:
        </label>
        <div class="col-6">
          <select class="form-select col-sm-auto"
                  data-testid="external-analysis-provider-select"
                  [(ngModel)]="hospitalDetails.externalAnalysisType">
            <option *ngFor="let provider of allExternalAnalysisTypes" [ngValue]="provider">{{ externalAnalysisTypeLabels[provider] }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <hr/>
  <div class="row justify-content-center mt-3 mb-3">
    <div class="col-6">
      <button class="btn btn-primary" data-testid="save-button" (click)="save()" [disabled]="!hospitalInformationValid">
        {{ localizationKey('editHospitalSaveButton') | localize }}
      </button>
    </div>
  </div>
</div>
